"use strict";
exports.__esModule = true;
exports.AccordionSummary = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importDefault(require("react"));
var Icon_1 = require("../Icon");
function AccordionSummary(props) {
    var children = props.children, _a = props.expandIcon, expandIcon = _a === void 0 ? react_1["default"].createElement(Icon_1.Icon, { color: "secondary", name: "expand_more" }) : _a, rest = tslib_1.__rest(props, ["children", "expandIcon"]);
    return (react_1["default"].createElement(core_1.AccordionSummary, tslib_1.__assign({ expandIcon: expandIcon }, rest), children));
}
exports.AccordionSummary = AccordionSummary;
//# sourceMappingURL=AccordionSummary.js.map